import { create } from 'zustand';
export type Toast = { id: string; kind: 'error' | 'success' | 'warning'; title: string; description?: string };
type S = { toasts: Toast[]; push: (t: Omit<Toast, 'id'>) => void; dismiss: (id: string) => void };
export const useToastStore = create<S>((set) => ({
  toasts: [],
  push: (t) => set((s) => ({ toasts: [...s.toasts, { ...t, id: crypto.randomUUID() }] })),
  dismiss: (id) => set((s) => ({ toasts: s.toasts.filter((x) => x.id !== id) })),
}));
export function useToast() {
  const push = useToastStore((s) => s.push);
  return { toast: push };
}

const TOAST_CLASS: Record<Toast['kind'], string> = {
  error:   'bg-rose-700 text-white',
  success: 'bg-emerald-700 text-white',
  warning: 'bg-amber-600 text-white',
};

export function Toaster() {
  const toasts = useToastStore((s) => s.toasts);
  return (
    <ol className="fixed right-4 top-4 z-50 flex flex-col gap-2">
      {toasts.map((t) => (
        <li key={t.id} role="status" className={`rounded px-3 py-2 ${TOAST_CLASS[t.kind] ?? TOAST_CLASS.error}`}>
          <p className="font-semibold">{t.title}</p>
          {t.description && <p className="text-sm">{t.description}</p>}
        </li>
      ))}
    </ol>
  );
}
